var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBurgerMenu = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 74.211 43.225"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "burger-menu_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  transform: "translate(897 145.712)",
  style: {
    stroke: "#707070",
    fill: "none",
    strokeWidth: 2
  },
  d: "M0 0h41.201v38.288H0z"
})), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".burger-menu_svg__c,.burger-menu_svg__d{fill:none;stroke-width:2px;stroke:#fff}.burger-menu_svg__d{stroke-miterlimit:10}"))), /*#__PURE__*/React.createElement("g", {
  style: {
    clipPath: "url(#burger-menu_svg__a)"
  },
  transform: "translate(-863.991 -145.712)"
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "burger-menu_svg__c",
  d: "M913.339 177.042a14.99 14.99 0 1 0-14.992-14.989 14.994 14.994 0 0 0 14.992 14.989ZM924.47 171.452l12.827 11.547"
}))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "burger-menu_svg__d",
  d: "M0 11.594h27.009M0 26.91h27.009M0 42.225h49.009"
})));
export default SvgBurgerMenu;